import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';


@Injectable()
export class ShareUiProvider {

  loadingUi:any;
  alertUi:any;

  monthNames = ["มกราคม,กุมภาพันธ์,มีนาคม,เมษายน,พฤษภาคม,มิถุนายน,กรกฎาคม,สิงหาคม,กันยายน,ตุลาคม,พฤศจิกายน,ธันวาคม","January,February,March,April,May,June,July,August,September,October,November,December","一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月"];
  pickadateOpt = [{monthsFull:['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'],monthsShort:['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],weekdaysFull:['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศกุร์','เสาร์'],weekdaysShort:['อ.','จ.','อ.','พ.','พฤ.','ศ.','ส.'],today:'วันนี้',clear:'',close: '',selectYears: 50,selectMonths: true,format: 'd mmmm yyyy',formatSubmit: 'yyyy-mm-dd',hiddenPrefix: 'submit__', hiddenSuffix:''},{monthsFull: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],weekdaysFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],today: 'Today',clear: '',close: '',selectYears: 50,selectMonths: true,format: 'd mmmm, yyyy',formatSubmit: 'yyyy-mm-dd',hiddenPrefix: 'submit__', hiddenSuffix:''},{monthsFull:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],monthsShort:['一','二','三','四','五','六','七','八','九','十','十一','十二'],weekdaysFull:['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],weekdaysShort:['日','一','二','三','四','五','六'],today:'今日',clear:'',close:'',selectYears: 50,selectMonths: true,format: 'yyyy 年 mm 月 dd 日',formatSubmit: 'yyyy-mm-dd',hiddenPrefix: 'submit__', hiddenSuffix:''}];

  instituteList = ['จุฬาลงกรณ์มหาวิทยาลัย','มหาวิทยาลัยกรุงเทพ','มหาวิทยาลัยกรุงเทพธนบุรี','มหาวิทยาลัยกรุงเทพสุวรรณภูมิ','มหาวิทยาลัยการจัดการและเทคโนโลยีอีสเทิร์น','มหาวิทยาลัยกาฬสินธุ์','มหาวิทยาลัยเกริก','มหาวิทยาลัยเกษตรศาสตร์','มหาวิทยาลัยเกษมบัณฑิต','มหาวิทยาลัยขอนแก่น','มหาวิทยาลัยคริสเตียน','มหาวิทยาลัยเจ้าพระยา','มหาวิทยาลัยเฉลิมกาญจนา','มหาวิทยาลัยชินวัตร','มหาวิทยาลัยเชียงใหม่','มหาวิทยาลัยเซนต์จอห์น','มหาวิทยาลัยตาปี','มหาวิทยาลัยทักษิณ','มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี','มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ','มหาวิทยาลัยเทคโนโลยีมหานคร','มหาวิทยาลัยเทคโนโลยีราชมงคลกรุงเทพ','มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก','มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี','มหาวิทยาลัยเทคโนโลยีราชมงคลพระนคร','มหาวิทยาลัยเทคโนโลยีราชมงคลรัตนโกสินทร์','มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา','มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย','มหาวิทยาลัยเทคโนโลยีราชมงคลสุวรรณภูมิ','มหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน','มหาวิทยาลัยเทคโนโลยีสุรนารี','มหาวิทยาลัยธนบุรี','มหาวิทยาลัยธรรมศาสตร์','มหาวิทยาลัยธุรกิจบัณฑิตย์','มหาวิทยาลัยนครพนม','มหาวิทยาลัยนราธิวาสราชนครินทร์','มหาวิทยาลัยนเรศวร','มหาวิทยาลัยนอร์ทกรุงเทพ','มหาวิทยาลัยนอร์ท-เชียงใหม่','มหาวิทยาลัยนานาชาติแสตมฟอร์ด','มหาวิทยาลัยนานาชาติเอเชีย-แปซิฟิก วิทยาเขตกรุงเทพ','มหาวิทยาลัยเนชั่น','มหาวิทยาลัยบูรพา','มหาวิทยาลัยปทุมธานี','มหาวิทยาลัยพะเยา','มหาวิทยาลัยพายัพ','มหาวิทยาลัยพิษณุโลก','มหาวิทยาลัยฟาฏอนี','มหาวิทยาลัยฟาร์อีสเทอร์น','มหาวิทยาลัยภาคกลาง','มหาวิทยาลัยภาคตะวันออกเฉียงเหนือ','มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย','มหาวิทยาลัยมหามกุฏราชวิทยาลัย','มหาวิทยาลัยมหาสารคาม','มหาวิทยาลัยมหิดล','มหาวิทยาลัยแม่โจ้','มหาวิทยาลัยแม่ฟ้าหลวง','มหาวิทยาลัยรังสิต','มหาวิทยาลัยรัตนบัณฑิต','มหาวิทยาลัยราชธานี','มหาวิทยาลัยราชพฤกษ์','มหาวิทยาลัยราชภัฏกาญจนบุรี','มหาวิทยาลัยราชภัฏกำแพงเพชร','มหาวิทยาลัยราชภัฏจันทรเกษม','มหาวิทยาลัยราชภัฏชัยภูมิ','มหาวิทยาลัยราชภัฏเชียงราย','มหาวิทยาลัยราชภัฏเชียงใหม่','มหาวิทยาลัยราชภัฏเทพสตรี','มหาวิทยาลัยราชภัฏธนบุรี','มหาวิทยาลัยราชภัฏนครปฐม','มหาวิทยาลัยราชภัฏนครราชสีมา','มหาวิทยาลัยราชภัฏนครศรีธรรมราช','มหาวิทยาลัยราชภัฏนครสวรรค์','มหาวิทยาลัยราชภัฏบ้านสมเด็จเจ้าพระยา','มหาวิทยาลัยราชภัฏบุรีรัมย์','มหาวิทยาลัยราชภัฏพระนคร','มหาวิทยาลัยราชภัฏพระนครศรีอยุธยา','มหาวิทยาลัยราชภัฏพิบูลสงคราม','มหาวิทยาลัยราชภัฏเพชรบุรี','มหาวิทยาลัยราชภัฏเพชรบูรณ์','มหาวิทยาลัยราชภัฏภูเก็ต','มหาวิทยาลัยราชภัฏมหาสารคาม','มหาวิทยาลัยราชภัฏยะลา','มหาวิทยาลัยราชภัฏร้อยเอ็ด','มหาวิทยาลัยราชภัฏราชนครินทร์','มหาวิทยาลัยราชภัฏรำไพพรรณี','มหาวิทยาลัยราชภัฏลำปาง','มหาวิทยาลัยราชภัฏเลย','มหาวิทยาลัยราชภัฏวไลยอลงกรณ์ ในพระบรมราชูปถัมภ์','มหาวิทยาลัยราชภัฏศรีสะเกษ','มหาวิทยาลัยราชภัฏสกลนคร','มหาวิทยาลัยราชภัฏสงขลา','มหาวิทยาลัยราชภัฏสวนสุนันทา','มหาวิทยาลัยราชภัฏสุราษฏร์ธานี','มหาวิทยาลัยราชภัฏสุรินทร์','มหาวิทยาลัยราชภัฏหมู่บ้านจอมบึง','มหาวิทยาลัยราชภัฏอุดรธานี','มหาวิทยาลัยราชภัฏอุตรดิตถ์','มหาวิทยาลัยราชภัฏอุบลราชธานี','มหาวิทยาลัยรามคำแหง','มหาวิทยาลัยวงษ์ชวลิตกุล','มหาวิทยาลัยวลัยลักษณ์','มหาวิทยาลัยเวสเทิร์น','มหาวิทยาลัยศรีนครินทรวิโรฒ','มหาวิทยาลัยศรีปทุม','มหาวิทยาลัยศิลปากร','มหาวิทยาลัยสงขลานครินทร์','มหาวิทยาลัยสยาม','มหาวิทยาลัยสวนดุสิต','มหาวิทยาลัยสุโขทัยธรรมาธิราช','มหาวิทยาลัยหอการค้าไทย','มหาวิทยาลัยหัวเฉียวเฉลิมพระเกียรติ','มหาวิทยาลัยหาดใหญ่','มหาวิทยาลัยอัสสัมชัญ','มหาวิทยาลัยอีสเทิร์นเอเชีย','มหาวิทยาลัยอุบลราชธานี','มหาวิทยาลัยเอเชียอาคเนย์','ราชวิทยาลัยจุฬาภรณ์','วิทยาลัยเฉลิมกาญจนาระยอง','วิทยาลัยชุมชน','วิทยาลัยเชียงราย','วิทยาลัยเซนต์หลุยส์','วิทยาลัยเซาธ์อีสท์บางกอก','วิทยาลัยดุสิตธานี','วิทยาลัยทองสุข','วิทยาลัยเทคโนโลยีจิตรลดา','วิทยาลัยเทคโนโลยีพนมวันท์','วิทยาลัยเทคโนโลยีภาคใต้','วิทยาลัยเทคโนโลยีสยาม','วิทยาลัยนครราชสีมา','วิทยาลัยนอร์ทเทิร์น','วิทยาลัยนานาชาติเซนต์เทเรซา','วิทยาลัยบัณฑิตเอเชีย','วิทยาลัยพิชญบัณฑิต','วิทยาลัยพุทธศาสนานานาชาติ','วิทยาลัยสันตพล','วิทยาลัยแสงธรรม','วิทยาลัยอินเตอร์เทคลำปาง','สถาบันกันตนา','สถาบันการจัดการปัญญาภิวัฒน์','สถาบันดนตรีกัลยาณิวัฒนา','สถาบันเทคโนโลยีไทย-ญี่ปุ่น','สถาบันเทคโนโลยีปทุมวัน','สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง','สถาบันเทคโนโลยียานยนต์มหาชัย','สถาบันเทคโนโลยีแห่งสุวรรณภูมิ','สถาบันบัณฑิตพัฒนบริหารศาสตร์','สถาบันรัชต์ภาคย์','สถาบันวิทยสิริเมธี','สถาบันวิทยาการจัดการแห่งแปซิฟิค','สถาบันอาศรมศิลป์'];

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController
  ) {
  }
  /**
   * show Loading ui create from LoadingController
   */
  loadingShow() : void{
    this.loadingUi = this.loadingCtrl.create({
      content: 'Loading'
    });
    this.loadingUi.present();
  }
  /**
   * hide Loading ui create from LoadingController
   */
  loadingHide() : void{
    this.loadingUi.dismiss();
  }
  /**
   * show Alert dialog ui create from AlertController
   * @param msg = message for user
   * @param err = err message of code for debug
   */
  showAlert(msg:string,err='') : void{
    this.alertUi = this.alertCtrl.create({
      title: 'Sorry',
      message: '<p class="err">'+err+'</p><p>'+msg+'</p>',
      buttons: ['Dismiss'],
      cssClass : 'error-msg'
    });
    this.alertUi.present();
  }
  /**
   * return ISO Date with local time
   * @param now = date obj
   */
  formatLocalDate(now:any) {
    var tzo = -now.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            var norm = Math.abs(Math.floor(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return now.getFullYear() 
        + '-' + pad(now.getMonth()+1)
        + '-' + pad(now.getDate())
        + 'T' + pad(now.getHours())
        + ':' + pad(now.getMinutes()) 
        + ':' + pad(now.getSeconds()) 
        + dif + pad(tzo / 60) 
        + ':' + pad(tzo % 60);
  }
  /**
   * return date format for pickadate.js
   * @param now = date obj
   */
  formatDate(now:any) {
    var pad = function(num) {
        var norm = Math.abs(Math.floor(num));
        return (norm < 10 ? '0' : '') + norm;
    };

    return now.getFullYear() + '-' + pad(now.getMonth()+1) + '-' + pad(now.getDate());
  }
  /**
   * 
   * @param status 
   */
  statusName(status:any){
    return status.toLowerCase();
  }
  /**
   * 
   * @param status 
   */
  statusColor(status:any){
    let color;
    status = this.statusName(status);
    switch(status) {
        case 'await payment':
            color = '#ff7700';
            break;
        case 'user rejected':
            color = '#666666';
            break;
        case 'rejected':
            color = '#ff0000';
            break;
        case 'request new proof':
            color = '#ff7700';
            break;
        case 'request new photo':
            color = '#ff7700';
            break;
        case 'await confirm':
            color = '#ffcc00';
            break;
        case 'register complete':
            color = '#0088ff';
            break;
        case 'schedule complete':
            color = '#aaff00';
            break;
        case 'waiting process':
            color = '#8800ff';
            break;
        case 'certificated':
            color = '#009920';
            break;
        case 'absent':
            color = '#ff0000';
            break;

        default:
        color = 'dark';
    }
    return color;
  }
}



// WEBPACK FOOTER //
// ./src/providers/share-ui/share-ui.ts